import { Empty } from "antd";

export default function ChartCard({
  title,
  children,
  empty = false,
  height = 300,
  accent,
}) {
  return (
    <section
      className="analytics-chart-card"
      style={accent ? { "--analytics-card-accent": accent } : undefined}
    >
      <div className="analytics-chart-card__head">
        <h3 className="analytics-chart-card__title">{title}</h3>
      </div>
      <div
        className={`analytics-chart-card__body${
          empty ? " analytics-chart-card__body--empty" : ""
        }`}
        style={{ height }}
      >
        {empty ? (
          <Empty
            image={Empty.PRESENTED_IMAGE_SIMPLE}
            description="Nuk ka të dhëna"
          />
        ) : (
          children
        )}
      </div>
    </section>
  );
}
